import React from "react";
import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-ink-600 bg-ink-800/60 text-zinc-200 hover:text-neon-cyan hover:border-neon-cyan/50 transition-colors text-xs"
      data-testid="theme-toggle"
    >
      {theme === "dark" ? <Sun size={14} weight="fill" /> : <Moon size={14} weight="fill" />}
    </button>
  );
}
